// FIFA 3-letter code → ISO 3166-1 alpha-2 code (lowercase for flag-icons).
// The 48 WC26 national teams use official FIFA codes; we map them to the
// two-letter ISO code that `flag-icons` (CSS sprite) expects.
//
// Real SVG flags — no OS emoji dependency, cross-platform-consistent
// (Windows Chrome, Mac, iOS, Android all render the same image).

export const FIFA_TO_ISO2 = {
  ALG:"dz", ARG:"ar", AUS:"au", AUT:"at", BEL:"be", BIH:"ba", BRA:"br",
  CAN:"ca", CIV:"ci", COD:"cd", COL:"co", CPV:"cv", CRO:"hr", CUW:"cw",
  CZE:"cz", ECU:"ec", EGY:"eg", ENG:"gb-eng", ESP:"es", FRA:"fr",
  GER:"de", GHA:"gh", HAI:"ht", IRN:"ir", IRQ:"iq", JOR:"jo", JPN:"jp",
  KOR:"kr", KSA:"sa", MAR:"ma", MEX:"mx", NED:"nl", NOR:"no", NZL:"nz",
  PAN:"pa", PAR:"py", POR:"pt", QAT:"qa", RSA:"za", SCO:"gb-sct",
  SEN:"sn", SUI:"ch", SWE:"se", TUN:"tn", TUR:"tr", URU:"uy", USA:"us",
  UZB:"uz", WAL:"gb-wls",
};

export const iso2Of = (fifa) => FIFA_TO_ISO2[(fifa || "").toUpperCase()] || null;
